<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
  >
    <path
      class="svg-secondary"
      d="M10.5,0A10.5,10.5,0,1,0,21,10.5,10.531,10.531,0,0,0,10.5,0Zm.525,14.5v1.116a.518.518,0,0,1-.525.525.483.483,0,0,1-.525-.525v-1.05a1.988,1.988,0,0,1-1.641-2.1.518.518,0,0,1,.525-.525.483.483,0,0,1,.525.525c0,1.05.788,1.116.984,1.116a1.342,1.342,0,0,0,1.378-1.378c0-.853-.591-1.247-1.575-1.706-.788-.394-1.706-.853-1.706-1.969a1.974,1.974,0,0,1,1.444-2.1h.2V5.447a.518.518,0,0,1,.525-.525.483.483,0,0,1,.525.525V6.5a3.441,3.441,0,0,1,1.575,1.116.473.473,0,0,1-.787.525,1.731,1.731,0,0,0-1.706-.722,1,1,0,0,0-.722,1.116c0,.394.394.656,1.181,1.05.919.459,2.1,1.05,2.1,2.559A2.774,2.774,0,0,1,11.025,14.5Z"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
